export const CHANGES_COLLECTION = "Changes";
export const PARAPLANNING_DOC_ID = "Paraplanning";
export const CATALOGS_SUBCOLLECTION = "Catalogs";
export const CATEGORIES_SUBCOLLECTION = "Categories";
export const ITEMS_SUBCOLLECTION = "Items";
export const VERSIONS_SUBCOLLECTION = "Versions";

export const DEFAULT_CATALOG_ID = "financial_planning";

export const PARAPLANNING_CATALOGS = [
  {
    id: "financial_planning",
    name: "Financial Planning",
    code: "FP",
    displayOrder: 1,
    categories: [
      { id: "pension_annuity", name: "Pension & Annuity", displayOrder: 1 },
      { id: "investment", name: "Investment", displayOrder: 2 },
      { id: "bundles", name: "Bundles", displayOrder: 3 },
      {
        id: "applications_implementation",
        name: "Applications / Implementation",
        displayOrder: 4,
      },
      {
        id: "other",
        name: "Other",
        displayOrder: 5,
      },
    ],
  },
  {
    id: "mortgage_protection",
    name: "Mortgage & Protection",
    code: "MP",
    displayOrder: 2,
    categories: [
      { id: "mortgage", name: "Mortgage", displayOrder: 1 },
      {
        id: "protection_general_insurance",
        name: "Protection & General Insurance",
        displayOrder: 2,
      },
    ],
  },
];

export const EMPTY_ITEM = {
  id: "",
  name: "",
  description: "",
  amount: "",
  amountPrefix: "",
  amountType: "fixed",
  currency: "GBP",
  displayOrder: 999,
  isActive: true,
  visibleOnFrontend: true,
  modifiers: [],
};

export const VERSION_BATCHES_SUBCOLLECTION = "VersionBatches";